import { render, staticRenderFns } from "./SpeedioIcon.vue?vue&type=template&id=4436b1e9&"
import script from "./SpeedioIcon.vue?vue&type=script&lang=ts&"
export * from "./SpeedioIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports